import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "react-bootstrap-icons";

interface CollapsibleSidebarProps {
    children: React.ReactNode;
    className?: string;
    header?: React.ReactNode;
}

export function CollapsibleSidebar({ children, className = "", header }: CollapsibleSidebarProps) {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const handleToggle = () => {
        setIsCollapsed(!isCollapsed);
    };

    // Dispatch custom event after transition completes to trigger grid recalculations
    useEffect(() => {
        const timer = setTimeout(() => {
            // Dispatch both standard resize and custom event
            window.dispatchEvent(new Event('resize'));
            window.dispatchEvent(new CustomEvent('sidebar-resize'));
        }, 350); // Slightly longer than 300ms transition

        return () => clearTimeout(timer);
    }, [isCollapsed]);

    return (
        <div
            className={`collapsible-sidebar ${isCollapsed ? "collapsed" : ""} ${className} d-none d-md-flex flex-column fullheight border-end`}
            style={{
                width: isCollapsed ? '80px' : undefined,
                minWidth: isCollapsed ? '80px' : undefined,
                maxWidth: isCollapsed ? '80px' : undefined,
                flex: isCollapsed ? '0 0 80px' : '0 0 auto'
            }}
        >
            <div className="sidebar-header">
                {!isCollapsed && header && (
                    <div className="sidebar-header-content">
                        {header}
                    </div>
                )}
                <button
                    className="sidebar-toggle-btn"
                    onClick={handleToggle}
                    aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                >
                    {isCollapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
                </button>
            </div>
            <div className="sidebar-content scroll-y-auto">
                {React.Children.map(children, child => {
                    if (React.isValidElement(child)) {
                        return React.cloneElement(child as React.ReactElement<any>, {
                            isCollapsed
                        });
                    }
                    return child;
                })}
            </div>
        </div>
    );
}

